import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * ROZET ÖNCELİĞİ (PRODUCT-DECISIONS §3.1)
 *   İndirim > Bugün Teslim > Çok Satan > Yeni
 * Bir kartta EN FAZLA İKİ rozet gösterilir; sıralama sorumluluğu
 * kart bileşenindedir, burada yalnızca görünüm tanımlıdır.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-2xs font-medium leading-snug',
  {
    variants: {
      tone: {
        /** İndirim — tek sıcak vurgu kullanımı */
        discount: 'bg-blush-600 text-white',
        /** Bugün teslim — bilgi rozeti, gürültü yapmaz */
        sameDay: 'bg-leaf-100 text-leaf-900',
        bestseller: 'bg-surface text-ink border border-line',
        fresh: 'bg-surface text-ink-muted border border-line',
        occasion: 'bg-gold-soft text-ink',
        soldOut: 'bg-surface-sunken text-ink-subtle',
      },
      placement: {
        /** Fotoğraf üzerinde: cam efekti, CTA rengi yok */
        onImage: 'backdrop-blur-sm shadow-soft',
        inline: '',
      },
    },
    defaultVariants: { tone: 'sameDay', placement: 'inline' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, placement, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ tone, placement }), className)} {...props} />
  );
}
